import React, { Component } from "react";
import "./Skills.css";
import { skills } from "../../portfolio";
import { Fade } from "react-reveal";

class SkillSection extends Component {
  render() {
    return (
      <div className="skills-list">
        {skills.data.map((skill, i) => {
          return (
            <div key={i} className="skills-main-div">
              <div className="skills-text-div">
                <Fade bottom duration={1000} distance="18px">
                  <h1 className="skills-heading">
                    {skill.title}
                  </h1>
                </Fade>
                <Fade bottom duration={1500} distance="20px">
                  <div className="skills-sentence-list">
                    {skill.skills.map((skillSentence, i) => {
                      return (
                        <p
                          key={i}
                          className="subTitle skills-text"
                        >
                          {skillSentence}
                        </p>
                      );
                    })}
                  </div>
                </Fade>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default SkillSection;
